'use client';

import React from 'react';
import { ourDifferences } from '@/static/ourDifferences';
import Image from 'next/image';

const OurDifferences: React.FC = () => {
  return (
    <section className="px-5 py-16">
      <div className="max-w-8xl mx-auto px-5 md:px-[50px]">
        <h2 className="mb-16 text-center text-3xl font-bold text-gray-800 lg:text-5xl lg:leading-tight">
          Upzi - người bạn đồng hành lý tưởng
        </h2>

        <div className="grid grid-cols-1 gap-8 md:grid-cols-3 lg:gap-12">
          {ourDifferences.map((item, index) => (
            <div
              key={index}
              className="flex flex-row items-center gap-4 text-left md:block md:gap-0 md:text-center"
            >
              <div className="flex basis-1/2 items-center justify-center md:mx-auto md:w-[200px]">
                {item.icon && (
                  <Image
                    src={item.icon}
                    alt={item.title}
                    width={700}
                    height={500}
                    className="h-auto w-full rounded-lg object-contain"
                    loading="lazy"
                    sizes="(min-width: 768px) 200px, 50vw"
                  />
                )}
              </div>
              <div className="basis-1/2">
                <h3 className="mb-2 text-lg font-semibold text-gray-800 md:mb-4 md:text-xl lg:text-2xl">
                  {item.title}
                </h3>
                <p className="text-sm leading-[1.5] text-gray-600 md:text-base">
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OurDifferences;
